import React from 'react';
import Modal from '../../common/Modal';
import FormField from '../../common/FormField';
import { useFormData } from '../../../hooks/useFormData';

/**
 * Supplier add/edit modal.
 * Before: 156 lines with duplicate style objects.  After: ~35 lines.
 */

const DEFAULTS = {
  supplier_id: '',
  supplier_name: '',
  contact_name: '',
  contact_number: '',
  email: '',
};

export default function SupplierModal({ isOpen, onClose, onSubmit, initialData, title }) {
  const { formData, handleChange } = useFormData(DEFAULTS, initialData, isOpen);

  return (
    <Modal isOpen={isOpen} onClose={onClose} onSubmit={() => onSubmit(formData)} title={title}>
      <div className="flex flex-col gap-1">
        <FormField name="supplier_id" label="Supplier ID (PK)" value={formData.supplier_id} onChange={handleChange} required disabled={!!initialData} />
        <FormField name="supplier_name" label="Supplier Name" value={formData.supplier_name} onChange={handleChange} required />
        <FormField name="contact_name" label="Contact Person" value={formData.contact_name} onChange={handleChange} />
        <FormField name="contact_number" label="Phone Number" value={formData.contact_number} onChange={handleChange} />
        <FormField name="email" label="Email" value={formData.email} onChange={handleChange} type="email" />
      </div>
    </Modal>
  );
}
